export default class NotFound extends Error {
    constructor(id) {
        super(`Id not found: ${id}`);
    }
}
